import { Container, Row, Col } from 'react-bootstrap';
import { MyProjects } from '../../components';

const Projects = () => {
    return (
        <Container fluid className="projects-page">
            <Row>
                <Col>
                    <h1 className="display-1">Projects</h1>
                    <div className="display-2">Manage and Track Your Projects</div>
                </Col>
            </Row>
            <Row className="mt-0 gy-4">
                <Col lg={12}>
                    <MyProjects />
                </Col>
            </Row>
        </Container>  
    );
};

export default Projects;